import wedding from '@/assets/icons/supportGoals/wedding-cake.svg';
import medical from '@/assets/icons/supportGoals/medical-cross.svg';
import monthly from '@/assets/icons/supportGoals/monthly-calender.svg';
import wheelchair from '@/assets/icons/supportGoals/wheelchair.svg';
import tooth from '@/assets/icons/supportGoals/clean-tooth.svg';
import saveMoney from '@/assets/icons/supportGoals/save-money-dollar.svg';
import raising from '@/assets/icons/supportGoals/raising.svg';
// Unused icons - keeping for potential future use
// import baby from '@/assets/icons/supportGoals/baby-boy.svg';
// import torah from '@/assets/icons/supportGoals/torah-2.svg';
// import student from '@/assets/icons/supportGoals/student.svg';
import jewish from '@/assets/icons/supportGoals/jewish.svg';
import wideBrimHat from '@/assets/icons/supportGoals/wide-brim-hat.svg';

export const IconsToGoals: Record<string, string | null> = {
  MonthlySupport: monthly,
  Wedding: wedding,
  BarMitzvah: wideBrimHat,
  UnusualExpense: null,
  AccessibilityEquipment: wheelchair,
  MedicalExpenses: medical,
  DentalTreatment: tooth,
  Kollel: jewish,
  FundExpenses: saveMoney,
  FundraisingExpenses: raising,
};

export default IconsToGoals;
